import { history, useIntl } from '@umijs/max';
import { Button, Card, Result } from 'antd';

export default function ForbiddenPage() {
  return (
    <Result
      status="403"
      title="403"
      subTitle="抱歉，你没有权限访问该页面。"
      extra={[
        <Button type="primary" key="home" onClick={() => history.push('/')}>
          返回首页
        </Button>,
        <Button key="back" onClick={() => history.back()}>
          返回上一页
        </Button>,
      ]}
    />
  );
}
